"use strict";

exports.__esModule = true;
var _CreateTicketWatcherRuleScreen = require("./CreateTicketWatcherRuleScreen");
Object.keys(_CreateTicketWatcherRuleScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CreateTicketWatcherRuleScreen[key]) return;
  exports[key] = _CreateTicketWatcherRuleScreen[key];
});